import _objectSpread from "/root/workspace/ubq-h5_build/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.error.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { validCode } from '@/utils/valid';
import { lsSetUserInfo, setToken } from '@/utils/auth';
import { mapGetters } from 'vuex';
export default {
  name: 'MandateAccount',
  props: {
    // 如果登陆后有其他操作，需要在父组件传入"登录"按钮loading状态
    loading: {
      type: Boolean,
      default: false
    },
    // 是否显示关闭叉叉
    closeable: {
      type: Boolean,
      default: true
    },
    // 验证登录后是否更新当前用户状态
    updateUserInfo: {
      type: Boolean,
      default: true
    },
    // 授权手机号
    phone: {
      type: [String, null],
      default: '暂无'
    },
    // 授权appKey
    appKey: {
      type: [String, null],
      default: ''
    },
    // 返回地址
    redirect: {
      type: [String, null],
      default: ''
    }
  },
  data: function data() {
    return {
      step: 1,
      submitLoading: false,
      codeLoading: false,
      modal: false,
      verifyCode: '',
      remainTime: null,
      rules: {
        code: [{
          required: true,
          validator: validCode,
          message: '请输入6位验证码'
        }]
      },
      timer: null,
      isVerifyCodeLogin: true // 是否为验证码登录，false=密码登录

    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['userInfo'])), {}, {
    codeDisabled: function codeDisabled() {
      return !this.phone || this.codeLoading || !!this.remainTime;
    },
    disabled: function disabled() {
      return !this.verifyCode;
    }
  }),
  watch: {
    loading: function loading(val) {
      this.submitLoading = val;
    },
    phone: function phone(val) {
      var _this$userInfo;

      if (((_this$userInfo = this.userInfo) === null || _this$userInfo === void 0 ? void 0 : _this$userInfo.phone) !== val) {
        this.modal = !!this.phone && !!this.appKey;
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    // 登录或者注册
    toRegister: function toRegister() {
      var _this = this;

      this.submitLoading = true;
      this.remainTime = null;
      var postData = {
        displayData: {
          // 随机昵称
          displayName: '优版权-' + Math.random().toString(36).substr(6),
          // 默认头像（上传是为了pc端，考虑是否不传该字段，前端来处理无头像的显示问题）
          avatar: this.$Setting.defaultAvatar
        },
        userSubject: {
          oncePassword: this.verifyCode,
          phone: this.phone,
          appKey: this.appKey
        },
        source: 'ubq'
      };
      this.$Register(postData).then(function (res) {
        _this.updateLoginInfo(res.data);

        _this.$toast('授权成功');

        _this.modal = false;
      }).catch(function () {}).finally(function () {
        _this.submitLoading = false;
      });
    },
    getCode: function getCode() {
      var _this2 = this;

      this.codeLoading = true;
      this.$GetVerifyCode({
        target: this.phone
      }).then(function () {
        _this2.remainTime = 60;
        _this2.timer = setInterval(function () {
          --_this2.remainTime;

          if (_this2.remainTime <= 0) {
            _this2.remainTime = null;
            clearInterval(_this2.timer);
          }
        }, 1000);
      }).finally(function () {
        _this2.codeLoading = false;
      });
    },
    updateLoginInfo: function updateLoginInfo(data) {
      if (this.updateUserInfo) {
        if (data) {
          this.$store.commit('user/SET_TOKEN', data.token);
          setToken(data.token);
          this.$store.commit('user/SET_USERINFO', data);
          lsSetUserInfo(data);
        }

        this.$store.dispatch('user/GetWalletStatus');
        this.$store.dispatch('user/GetTradePwd');
      }
    },
    goBank: function goBank() {
      var callBackRoute = window.decodeURIComponent(this.redirect);

      if (this.redirect && callBackRoute) {
        window.location.href = callBackRoute;
      } else {
        this.modal = false;
      }
    }
  }
};